<div class="btn-menu-container">
	<p-button (click)="showSidebar()" icon="fa fa-bars"></p-button>
</div>

<p-drawer id="app-sidebar" [(visible)]="sidebarVisible" position="right">
	<p-panelMenu [model]="menuItems" [multiple]="false"></p-panelMenu>
</p-drawer>
